import { ResponsivePie } from '@nivo/pie'

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const MyResponsivePie = ({ data /* see data tab */ }) => (
    <div style={{ height: 300, backgroundColor:"rgba(0, 0, 0, 0.0)"}}>
        <ResponsivePie
            data={data}
            margin={{ top: 10, right: 0, bottom: 10, left: 0 }}
            innerRadius={0.65}
            padAngle={3}
            cornerRadius={10}
            activeOuterRadiusOffset={5}
            borderWidth={1}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'opacity',
                        0.2
                    ]
                ]
            }}
            colors={["#38FF8E", "#222222"]}
            // to remove arcs do following
            // arcLinkLabelComponent={"false"}
            // to remove label do following
            // arcLabel={null}
            arcLinkLabelsDiagonalLength={2}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="black"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            // arcLabelsTextColor={{
            //     from: 'color',
            //     modifiers: [
            //         [
            //             'darker',
            //             2
            //         ]
            //     ]
            // }}
            arcLabelsTextColor="white"
            defs={[
                {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: 'rgba(255, 255, 55, 0.3)',
                    size: 4,
                    padding: 1,
                    stagger: true
                },
                {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'red',
                    color: 'rgba(255, 255, 25, 0.3)',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                }
            ]}
        />

    </div>
)

export default MyResponsivePie;